import { cn } from '../../../lib/styles';
import { Icon } from '../icon/icon.spark';
import type { BadgeProps, BadgeSize } from './types';

const SIZE_MAP: Record<BadgeSize, string> = {
  md: 'px-2 py-1',
  sm: 'px-1.5 py-0.5',
};

export function Badge(_props: BadgeProps) {
  const { variant = 'default', size = 'md', iconSize = 'xs', ...props } = _props;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-x-1 whitespace-nowrap rounded-lg border border-black/15 text-xs',
        SIZE_MAP[size],
        props.truncate ? 'h-fit min-w-0 max-w-full' : 'size-fit',
        {
          'bg-gray-100 text-spark-text-primary': variant === 'default',
          'bg-white text-spark-text-primary': variant === 'white',
          'bg-platform-primary/10 text-platform-primary': variant === 'primary',
          'bg-cyan-100 text-cyan-700': variant === 'blue',
          'bg-violet-100 text-indigo-800': variant === 'purple',
          'bg-orange-100 text-orange-800': variant === 'orange',
          'bg-green-100 text-green-800': variant === 'green',
          'bg-yellow-100 text-orange-800': variant === 'yellow',
          'bg-red-100 text-red-800': variant === 'red',
          'cursor-pointer': props.interactive,
        },
      )}
    >
      {props.icon && (
        <span aria-hidden className="inline-flex h-4 shrink-0 items-center">
          <Icon name={props.icon} size={iconSize} />
        </span>
      )}
      {props.truncate ? <span className="truncate">{props.children}</span> : props.children}
    </div>
  );
}
